module.exports = __webpack_public_path__ + "static/img/listing-hero-placeholder.62485aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/listing-hero-placeholder.png
// module id = Zh1L
// module chunks = 1